module.exports = __webpack_public_path__ + "static/media/teacheradminguide.b122b7a9.pdf";